import styled from '@emotion/styled';

export const ErrorText = styled.div`
  color: ${({theme}) => theme.colors.reds.base};
`;
